import React from 'react';
import { applyComponentTheme } from '../../theme';
import {
  AnimatedSvg,
  BackgroundCircle,
  Container,
  InnerContainer,
  SpinnerColor,
  StyledCircle,
} from './styles';

type Props = {
  color?: SpinnerColor;
};

const spinnerCircleDimensionProps = {
  cx: '160',
  cy: '160',
  r: '138',
};

/**
 * A component to display a loading spinner.
 *
 * @param color - the stroke color of the spinner
 */
const Spinner: React.FC<Props> = ({ color, ...props }) => (
  <Container {...props}>
    <InnerContainer aria-hidden>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320">
        <BackgroundCircle {...spinnerCircleDimensionProps} />
      </svg>
    </InnerContainer>
    <InnerContainer aria-hidden>
      {/* All styling values except stroke color and background ring provided by an older spinner */}
      <AnimatedSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320">
        <StyledCircle strokeColor={color} {...spinnerCircleDimensionProps} />
      </AnimatedSvg>
    </InnerContainer>
  </Container>
);

export default applyComponentTheme(Spinner, 'Spinner');
